export default __webpack_public_path__ + "static/media/jeaImg.9c6318da.svg";